module.exports = {
      id: "dropdown-usage",
      viewBox: "0 0 12 10",
      url: "img/" + "sprite.svg#dropdown-usage",
      toString: function () {
        return this.url;
      }
    }